import { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { GridOverlay, GridOverlayProps } from '@mui/x-data-grid-pro';
import { useIsMounted } from '@bymason/util-hooks';
import { NoResults } from '../../../widgets';

export interface EmptySearchOverlayProps extends GridOverlayProps {
  searchCompleted?: boolean;
  message?: string;
}

export function DataGridEmptySearchOverlay({
  searchCompleted = true,
  message,
  ...overlayProps
}: EmptySearchOverlayProps) {
  const isMounted = useIsMounted();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowContent(searchCompleted && isMounted());
    }, 250);
  }, [isMounted, searchCompleted]);

  return <GridOverlay {...overlayProps}>{showContent && <NoResults message={message} />}</GridOverlay>;
}

export const DataGridLoadingOverlay = (overlayProps: GridOverlayProps) => {
  return (
    <GridOverlay {...overlayProps}>
      <LinearProgress style={{ left: 0, position: 'absolute', top: 0, width: '100%' }} />
    </GridOverlay>
  );
};

export const DataGridLoadingOverlayWithBottom = (overlayProps: GridOverlayProps) => {
  return (
    <GridOverlay {...overlayProps}>
      <LinearProgress style={{ left: 0, position: 'absolute', top: 0, width: '100%' }} />
      <LinearProgress style={{ left: 0, position: 'absolute', bottom: 0, width: '100%' }} />
    </GridOverlay>
  );
};
